module.exports = __webpack_public_path__ + "static/001fa07d-bc0e-4d40-aa26-6e4e765f52ca-c8af527594cc42a4a7c33f20c05e1989.webp";